import { useEffect } from 'react';

import { useChannelsStore } from '@/components/pages/channels/use-channels-store';

// Custom hook to manage refetch functions
export function useCampaignRefetch(refetchFn: () => Promise<void>) {
  const addRefetchFunction = useChannelsStore(s => s.addRefetchFunction);

  useEffect(() => {
    addRefetchFunction(refetchFn);

    // Remove the refetch function when the component unmounts
    return () => {
      const state = useChannelsStore.getState();
      const newRefetchFunctions = state.refetchFunctions.filter(
        fn => fn !== refetchFn,
      );
      useChannelsStore.setState({ refetchFunctions: newRefetchFunctions });
    };
  }, [addRefetchFunction, refetchFn]);
}
